module.exports = __webpack_public_path__ + "media/images/emblems/Wiggiswil-coat_of_arms-d2a4dd93c3006d4fcdd56e63c806aae0.svg";